import { ReactElement } from 'react';
import { Component as WarningIcon } from 'icons/icon-color--warning.svg';
import styles from './Banner.module.scss';

type Props = {
  remainingCartMinimum: string;
  cartMinimum: string;
}

export function CartMinimumBanner({ remainingCartMinimum, cartMinimum }: Props): ReactElement {
  return (
    <div className={`${styles.banner_container} ${styles.warning_banner}`}>
      <WarningIcon />
      <div>
        <span style={{ fontWeight: 'bold' }}>{`${cartMinimum} minimum order.`}</span>
        {` Add ${remainingCartMinimum} to cart.`}
      </div>
    </div>
  );
}
